import { render, staticRenderFns } from "./RecentUpdatedPayments.vue?vue&type=template&id=89b3e4a6"
import script from "./RecentUpdatedPayments.vue?vue&type=script&lang=js"
export * from "./RecentUpdatedPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports